import MainServices from "./Main.services";

class ScrapeServices {
    constructor() { }

    async getListKeywords(reqData, callBackStart) {
        const { account, signedUsergroup } = MainServices.userDetails();
        const [usergroup, accountName] = signedUsergroup?.usergroupName.split("~")

        const path = "keywordmanagement/keywords/keyworddetails"
        let params = {
            ...{
                account: account,
                user_group: usergroup
            },
            ...reqData
        }

        callBackStart(params, MainServices.url + path);
        return await MainServices.get({ path, params });
    }

    async addKeywords(reqData, callBackStart) {
        const { account, signedUsergroup, fullname } = MainServices.userDetails();
        const [usergroup, accountName] = signedUsergroup?.usergroupName.split("~");

        let params = {
            data: {
                ...{
                    user: fullname,
                    account: account,
                    user_group: usergroup,
                },
                ...reqData
            }
        }
        const url = `${MainServices.url}keywordmanagement/keywords`
        callBackStart(params, url);
        return await MainServices.post(url, params, { noCredentials: false });
    }

    async getListKeywordsDetails(keywords = [], country_code, market_package, module, callBackStart) {
        const params = { keywords, country_code, market_package, module }
        const url = MainServices.url + "keywordmanagement/keywords/keyworddetails/status"
        callBackStart(params, url);
        return MainServices.post(url, params, { noCredentials: false });
    }

    runScrape(data, callBackStart) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    url,
                    userDetailsCache: { account, signedUsergroup, fullname },
                } = MainServices;

                const [usergroup, accountName] =
                    signedUsergroup?.usergroupName.split("~");

                const reqData = {
                    data: {
                        ...{
                            user: fullname,
                            account: account,
                            user_group: usergroup,
                            market_package: "",
                            module: "",
                        },
                        ...data,
                    },
                };
                const reqUrl = `${url}keywordmanagement/keywords`;
                const promise = MainServices.post(reqUrl, reqData, { noCredentials: false });
                callBackStart(reqData, reqUrl);
                const response = await promise;
                resolve(response);
            } catch (error) {
                resolve(null);
            }
        });
    }
}

export default new ScrapeServices();
